<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Multiselect from 'vue-multiselect'
import McButton from '@/components/McButton'
import McButtonBack from '@/components/McButtonBack'
import McDatePicker from '@/components/McDatePicker'
import { Helper } from '@/mixin/helper'
import moment from 'moment'

import {
  DEVICE_MUTATION_DELETE,
  DEVICE_MUTATION_UPDATE,
  GET_DEVICES,
  GET_DEVICE_HISTORIES,
  GET_DEVICE_LOGS,
} from '@/services/api/master/tracking'
import { mapGetters } from 'vuex'
/**
 * Starter component
 */
export default {
  page: {
    title: 'Data Tracking',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    McButton,
    McButtonBack,
    McDatePicker,
  },
  mixins: [Helper],
  apollo: {
    devices: {
      query: GET_DEVICES,
      variables() {
        return {
          filter: {
            vendorCode: this.filterApi.vendorCode,
            deviceCode: this.filterApi.deviceCode,
            status: this.filterApi.status,
            orderBy: this.filterApi.orderBy,
          },
        }
      },
      result({ data, loading }) {
        if (loading) return
        this.totalRows = data.devices.devices.length
        this.filteredItems = data.devices.devices
      },
    },
    deviceHistories: {
      query: GET_DEVICE_HISTORIES,
      skip() {
        return !this.form.imei
      },
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            imei: this.form.imei,
          },
        }
      },
      result({ data, loading }) {
        if (loading) return
        data.deviceHistories.deviceHistories.forEach((row) => {
          row.activeOnDateFormat = this.momentDateShortMonth(row.activeOn)
          row.activeOnTimeFormat = this.momentTime(row.activeOn)

          row.inactiveOnDateFormat = this.momentDateShortMonth(row.inactiveOn)
          row.inactiveOnTimeFormat = this.momentTime(row.inactiveOn)
        })

        this.historyRows = data.deviceHistories.deviceHistories.length
        this.history = data.deviceHistories.deviceHistories
      },
    },
    deviceLogs: {
      query: GET_DEVICE_LOGS,
      skip() {
        return !this.form.imei
      },
      fetchPolicy: 'no-cache',
      variables() {
        return {
          filter: {
            imei: this.form.imei,
            startDate: this.startDateLogs,
            endDate: this.endDateLogs,
          },
        }
      },
      result({ data, loading }) {
        if (loading) return
        data.deviceLogs.deviceLogs.forEach((row) => {
          row.messageOnDateFormat = this.momentDateShortMonth(row.messageOn)
          row.messageOnTimeFormat = this.momentTime(row.messageOn)
          row.type = ''

          if (row.message.includes('TEMPERATURE')) {
            row.type = 'temperature'
            row.description = JSON.parse(row.description)
          }
        })

        this.activityRows = data.deviceLogs.deviceLogs.length
        this.activity = data.deviceLogs.deviceLogs
      },
    },
  },
  data() {
    return {
      phaseOneShow: false,
      filterApi: {
        vendorCode: null,
        deviceCode: null,
        status: null,
        orderBy: [JSON.stringify({ imei: 'asc' })],
      },
      selected: {
        tracking: [],
      },
      selectedModel: {
        tracking: [],
      },
      allSelected: {
        tracking: false,
      },
      indeterminate: {
        tracking: true,
      },
      filterMonth: '',
      license_plat: null,
      lokasi: null,
      fav: null,
      vendor: null,
      tipePerangkat: null,
      filterHistory: null,
      filterActivity: null,
      totalRows: 1,
      historyRows: 0,
      activityRows: 0,
      currentPage: 1,
      historyPage: 1,
      activityPage: 1,
      perPage: 10,
      historyPerPage: 5,
      activityPerPage: 5,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      sortBy: 'imei',
      sortDesc: false,
      form: {
        identifier: null,
        deviceCode: null,
        vendorCode: null,
        portKernel: 8099,
        companyId: 1,
        imei: null,
        phoneNo: null,
        status: 0,
      },
      formOld: {
        identifier: null,
        deviceCode: null,
        vendorCode: null,
        portKernel: 8099,
        companyId: 1,
        imei: null,
        phoneNo: null,
        status: 0,
      },
      show_model: null,
      show: [
        { key: 'imei', label: this.$t('master.form.tracker.imei') },
        { key: 'identifier', label: this.$t('master.form.tracker.trackerId') },
        { key: 'vendorType', label: this.$t('master.form.tracker.vendor') },
        { key: 'deviceName', label: this.$t('master.form.tracker.deviceType') },
        { key: 'phoneNo', label: this.$t('master.form.tracker.phoneNo') },
        { key: 'status', label: this.$t('master.form.tracker.status') },
      ],
      isAddFavorit: false,
      addFavorit: null,
      showModal: false,

      vendorCode: [
        {
          key: 0,
          labelName: 'McEasy',
        },
        {
          key: 1,
          labelName: 'EasyGo',
        },
        {
          key: 2,
          labelName: 'Foxlogger',
        },
        {
          key: 3,
          labelName: 'SuperSpring',
        },
        {
          key: 100,
          labelName: 'Other',
        },
      ],

      deviceCode: [
        {
          key: 1001,
          labelName: 'Concox GT06N',
        },
        {
          key: 1002,
          labelName: 'Concox X3',
        },
        {
          key: 1003,
          labelName: 'Concox JC400 (Dashboard Camera)',
        },
      ],

      devices: {
        devices: [],
      },

      deviceHistories: {
        deviceHistories: [],
      },

      startDateLogs: moment().subtract(2, 'days').toDate().toISOString(),
      endDateLogs: moment().toDate().toISOString(),
      deviceLogs: {
        deviceLogs: [],
      },

      formStatus: 'update',
      status: '',
      listDeleted: [],

      filteredItems: [],
      periode: [moment().subtract(2, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
    }
  },

  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.devices.devices.length
    },

    title() {
      return this.$t('master.pelacak')
    },

    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        let result = this.show_model.map((a) => a.key)

        return this.tracking.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.tracking
      }
    },

    totalTrue() {
      return this.selectedModel.tracking.filter((c) => c === true)
    },

    tracking() {
      return [
        {
          key: 'imei',
          label: this.$t('master.list.tracker.imei'),
          sortable: true,
        },
        {
          key: 'identifier',
          label: this.$t('master.form.tracker.trackerId'),
          sortable: true,
        },
        {
          key: 'vendorType',
          label: this.$t('master.list.tracker.vendor'),
          sortable: true,
        },
        {
          key: 'deviceName',
          label: this.$t('setting.list.tracker.deviceType'),
          sortable: true,
        },
        {
          key: 'phoneNo',
          label: this.$t('master.list.tracker.phoneNo'),
          sortable: true,
        },
        {
          key: 'status',
          label: this.$t('master.list.tracker.status'),
          sortable: true,
        },
      ]
    },

    listHistory() {
      return [
        {
          key: 'licensePlate',
          label: this.$t('master.kendaraan'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'imei',
          label: 'IMEI',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'phoneNo',
          label: this.$t('master.form.tracker.phoneNo'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'activeOn',
          label: this.$t('master.form.tracker.activeOn'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'inactiveOn',
          label: this.$t('master.form.tracker.inactiveOn'),
          thClass: 'mc-table--50',
          sortable: true,
        },
      ]
    },

    activityHistory() {
      return [
        {
          key: 'title',
          label: this.$t('master.form.tracker.historyType'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'messageOn',
          label: this.$t('master.form.tracker.messageOn'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'description',
          label: this.$t('master.form.tracker.description'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'name',
          label: this.$t('master.form.tracker.user'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'licensePlate',
          label: this.$t('master.kendaraan'),
          thClass: 'mc-table--50',
          sortable: true,
        },
      ]
    },
    makeShortcuts() {
      return [
        { text: this.$t('global.time.today'), onClick: () => [new Date(), new Date()] },
        {
          text: this.$t('global.time.yesterday'),
          onClick: () => {
            const dateStart = new Date()
            const dateEnd = new Date()
            dateEnd.setTime(dateEnd.getTime() - 3600 * 1000 * 24)
            dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 24)
            dateStart.setHours(0, 0, 0, 0)
            dateEnd.setHours(23, 59, 59, 999)
            return [dateStart, dateEnd]
          },
        },
        {
          text: this.$t('delivery.filter.last3Days'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setDate(startDate.getDate() - 2)
            startDate.setHours(0, 0, 0)
            endDate.setHours(23, 59, 59)

            return [startDate, endDate]
          },
        },
      ].map((shortcut) => ({ ...shortcut, value: shortcut.onClick }))
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
  },
  methods: {
    /**
     * Search the table data with search input
     */
    focusSearch() {
      this.$refs.searchInput.focus()
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    onFilteredHistory(filteredItems) {
      this.historyRows = filteredItems.length
      this.historyPage = 1
    },

    onFilteredActivity(filteredItems) {
      this.activityRows = filteredItems.length
      this.activityPage = 1
    },

    onRowClicked(item) {
      this.resetModal()
      if (!this.hasAccessAll(['devices:update', 'd2a-default-mdpelacak:read'])) return
      this.form = {
        identifier: item.identifier,
        deviceCode: item.deviceCode,
        vendorType: item.vendorType,
        imei: item.imei,
        phoneNo: item.phoneNo,
        status: item.status == 1 || item.status == 0 ? 0 : 2,
      }

      this.formOld = {
        identifier: item.identifier,
        deviceCode: item.deviceCode,
        vendorType: item.vendorType,
        imei: item.imei,
        phoneNo: item.phoneNo,
        status: item.status == 1 || item.status == 0 ? 0 : 2,
      }

      this.formStatus = 'update'
      this.$bvModal.show('modal-create')
    },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value
    },

    toggleAll(checked, param) {
      this.selectedModel[param] = []
      this.selected[param] = []
      if (checked) {
        for (let i = 0; i < this.devices.devices.length; i++) {
          this.selected[param].push(i)
          this.selectedModel[param].push(true)
        }
      } else {
        for (let i = 0; i < this.devices.devices.length; i++) {
          this.selectedModel[param].push(false)
        }
        this.selected[param] = []
      }
    },

    checkTable(event, data, param) {
      if (event) {
        this.selected[param].push(data)
      } else {
        let myIndex = this.selected[param].indexOf(data)
        if (myIndex !== -1) {
          this.selected[param].splice(myIndex, 1)
        }
      }
    },

    toDelete() {
      let promises = []
      for (let i = 0; i < this.selected.tracking.length; i++) {
        promises.push(
          this.$apollo.mutate({
            mutation: DEVICE_MUTATION_DELETE,
            variables: {
              imei: this.selected.tracking[i].imei,
            },
          })
        )
      }

      Promise.all(promises).then(() => {
        this.$apollo.queries.devices.refetch()
        this.clearDelete()
        this.$mcToast.success(this.$t('global.alert.text.delete'))
      })
    },
    clearDelete() {
      this.allSelected.tracking = false
      this.selectedModel.tracking = []
      this.selected.tracking = []
    },
    resetModal() {
      this.form = {
        identifier: null,
        deviceCode: null,
        vendorCode: null,
        imei: null,
        phoneNo: null,
        status: 0,
      }
    },

    handleSubmitForm() {
      this.$refs.formRef.formSubmitted()
    },

    handleSubmit() {
      let input = {
        identifier: this.form.identifier,
      }

      input = {
        oldData: { identifier: this.formOld.identifier },
        newData: input,
        imei: this.form.imei,
      }
      this.$apollo
        .mutate({
          mutation: DEVICE_MUTATION_UPDATE,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (response) {
            if (response.data.updateDevice.isSuccessful) {
              this.$apollo.queries.devices.refetch()
              this.$mcToast.success(this.$t('global.alert.text.changed'))
            } else {
              let errMsg = response.data.updateDevice.message
              if (errMsg == 'Error: "User not authorized"') {
                return this.$mcToast.error(this.$t('master.form.tracker.noAccess'))
              } else {
                return this.$mcToast.warning(response.data.updateDevice.message)
              }
            }
          }
        })
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-create')
      })
    },
    changeStatus(status) {
      this.status = status
      if (this.selected.tracking.length > 0) {
        this.showModal = true
      } else {
        this.$mcToast.error(this.$t('global.alert.text.errorMinimum'))
      }
    },
    toChangeStatus() {
      let promises = []
      for (let i = 0; i < this.selected.tracking.length; i++) {
        promises.push(
          this.$apollo.mutate({
            mutation: DEVICE_MUTATION_UPDATE,
            variables: {
              input: {
                imei: this.selected.tracking[i].imei,
                status: this.status == 'Aktif' ? 0 : 2,
              },
            },
          })
        )
      }

      Promise.all(promises).then(() => {
        this.$mcToast.success(this.$t('global.alert.text.trackerStatusChanged', { total: this.selected.tracking.length }))
        this.showModal = false
        this.$apollo.queries.devices.refetch()
        this.clearDelete()
      })
    },
    openModalHistoryTracker() {
      this.$apollo.queries.deviceHistories.refetch()
      this.$apollo.queries.deviceLogs.refetch()
    },
    async deviceLogsReset() {
      const startDate = new Date()
      const endDate = new Date()

      startDate.setDate(startDate.getDate() - 2)
      startDate.setHours(0, 0, 0)
      endDate.setHours(23, 59, 59)
      this.startDateLogs = startDate.toISOString()
      this.endDateLogs = endDate.toISOString()
      this.periode = [this.formatDatePickerValue(startDate), this.formatDatePickerValue(endDate)]
      await this.$nextTick()
      this.$apollo.queries.deviceLogs.refetch()
    },
    async changeDateRange() {
      if (!this.periode || !this.periode[0] || !this.periode[1]) return

      const [dateStart, dateEnd] = this.normalizeDateRange(this.periode[0], this.periode[1])
      const startDate = new Date(dateStart)
      const endDate = new Date(dateEnd)

      startDate.setHours(0, 0, 0)
      endDate.setHours(23, 59, 59)
      this.startDateLogs = startDate.toISOString()
      this.endDateLogs = endDate.toISOString()
      this.periode = [this.formatDatePickerValue(startDate), this.formatDatePickerValue(endDate)]
      await this.$nextTick()
      this.$apollo.queries.deviceLogs.refetch()
    },
    normalizeDate(date) {
      const normalizedDate = new Date(date)
      normalizedDate.setHours(0, 0, 0, 0)
      return normalizedDate
    },
    normalizeDateRange(startDateValue, endDateValue) {
      const maxRangeDays = 3
      const maxRangeTime = (maxRangeDays - 1) * 24 * 60 * 60 * 1000
      let startDate = this.normalizeDate(startDateValue)
      let endDate = this.normalizeDate(endDateValue)
      const today = this.normalizeDate(new Date())

      if (startDate > today) {
        startDate = today
      }

      if (endDate > today) {
        endDate = today
      }

      if (startDate > endDate) {
        const selectedEndDate = endDate
        endDate = startDate
        startDate = selectedEndDate
      }

      if (endDate.getTime() - startDate.getTime() > maxRangeTime) {
        endDate = new Date(startDate.getTime() + maxRangeTime)
      }

      if (endDate > today) {
        endDate = today
        startDate = new Date(today.getTime() - maxRangeTime)
      }

      return [startDate, endDate]
    },
    disabledDateLogs(date, currentValue) {
      const maxRangeDays = 3
      const maxRangeTime = (maxRangeDays - 1) * 24 * 60 * 60 * 1000
      const currentDate = this.normalizeDate(date)
      const today = this.normalizeDate(new Date())

      if (currentDate > today) {
        return true
      }

      if (currentValue && currentValue[0] && !currentValue[1]) {
        const startDate = this.normalizeDate(currentValue[0])
        const minDate = new Date(startDate.getTime() - maxRangeTime)
        const maxDate = new Date(Math.min(startDate.getTime() + maxRangeTime, today.getTime()))

        return currentDate < minDate || currentDate > maxDate
      }

      return false
    },
    formatDatePickerValue(date) {
      const year = date.getFullYear()
      const month = `${date.getMonth() + 1}`.padStart(2, '0')
      const day = `${date.getDate()}`.padStart(2, '0')

      return `${year}-${month}-${day}`
    },
    closeCalendar() {
      if (this.$refs.periodePicker) {
        this.$refs.periodePicker.cancel()
      }
    },
  },
}
</script>
<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />

      <p class="mb-4">
        {{ $t('master.textKendaraan') }}
      </p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-dropdown
            v-if="phaseOneShow"
            right
            variant="outline-primary"
            menu-class="dropdown-menu-end"
            class="mc-btn-download"
          >
            <template #button-content>
              {{ $t('global.action.download') }} <i class="mdi mdi-chevron-down ps-2" />
            </template>
            <b-dropdown-item>
              <i class="bx bx-book-content pe-1" />
              {{ $t('master.user.downloadTable') }}
            </b-dropdown-item>
            <b-dropdown-item>
              <i class="bx bx-book-content pe-1" />
              {{ $t('master.user.downloadPDF') }}
            </b-dropdown-item>
          </b-dropdown>
          <McButtonBack class="ms-3" />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-12 text-end">
          <div class="mc-table-filter">
            <a
              v-if="phaseOneShow"
              v-b-modal.modal-filter
              class="popup-form btn btn-outline-primary me-3 mc-btn-filter"
              href="javascript: void(0);"
            >
              <i class="mc-fa icon-outline_filter" />
              {{ $t('global.object.filter') }}
            </a>
            <b-dropdown v-if="phaseOneShow" variant="outline-primary">
              <template #button-content>
                {{ $t('global.action.update') }} {{ $t('master.list.tracker.status') }}
                <i class="mdi mdi-chevron-down" />
              </template>
              <b-dropdown-item @click="changeStatus('Aktif')">
                {{ $t('global.active') }}
              </b-dropdown-item>
              <b-dropdown-item @click="changeStatus('Arsip')">
                {{ $t('global.archive') }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <!-- Search -->
          <div class="col-sm-12 col-md-12 d-flex flex-row-reverse mc-table-view-wrapper">
            <div class="mc-table-view">
              <p class="mc-label">
                {{ $t('global.action.show') }}
              </p>
              <multiselect
                v-model="show_model"
                :options="show"
                :multiple="true"
                :placeholder="$t('global.allColumn')"
                track-by="label"
                label="label"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  {{ option.name }}
                </template>
              </multiselect>
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                <label
                  class="d-inline-flex align-items-center mc-table-view__search"
                  @click="focusSearch"
                >
                  <i class="mc-fa fas fa-search" />
                  <b-form-input
                    v-model="filter"
                    type="search"
                    :placeholder="$t('global.search') + '...'"
                    class="form-control ms-2"
                    ref="searchInput"
                  />
                </label>
              </div>
            </div>
          </div>
          <!-- End search -->
        </div>

        <!-- Table Tracking -->
        <div class="table-responsive my-3 border border-1">
          <b-table
            class="datatables"
            :items="devices.devices"
            :fields="visibleFields"
            responsive="lg"
            show-empty
            :empty-text="$t('global.emptyTable')"
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            :busy="$apollo.queries.devices.loading"
            @filtered="onFiltered"
            @row-clicked="onRowClicked"
            @hidden="resetModal"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle" />
              </div>
            </template>

            <template #cell(imei)="data">
              <strong class="text-primary">
                {{ data.item.imei }}
              </strong>
            </template>

            <template #cell(status)="data">
              <span
                v-if="data.item.status === 0 || data.item.status === 1"
                class="mc-status mc-status--green"
              >
                {{ $t('global.active') }}
              </span>
              <span v-else-if="data.item.status === 2" class="mc-status mc-status--grey">
                {{ $t('global.archive') }}
              </span>
            </template>
          </b-table>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                {{ $t('global.show') }}
                <b-form-select
                  v-model="perPage"
                  class="form-select form-select-sm"
                  size="sm"
                  :options="pageOptions"
                />
                {{ $t('global.entry') }}.
                <p>
                  {{ $t('global.show') }}
                  <strong>{{
                    filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0
                  }}</strong>
                  {{ $t('global.object.to') }}
                  <strong>{{ Math.min(filteredItems.length, currentPage * perPage) }}</strong>
                  {{ $t('global.object.of') }}
                  <strong>{{ filteredItems.length }}</strong>
                  {{ $t('global.entry') }}.
                </p>
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows == null ? rows : totalRows"
                  :per-page="perPage"
                />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Create -->
    <b-modal
      id="modal-create"
      ref="modal-create"
      size="lg"
      :title="$t('master.form.tracker.change')"
      centered
      footer-class="d-flex justify-content-between"
      @hidden="resetModal"
    >
      <FormulateForm ref="formRef" v-model="form" @submit="handleSubmit">
        <b-row>
          <!-- IMEI -->
          <b-col md="3">
            <div class="mb-3">
              <span class="d-block text-muted">{{ $t('master.form.tracker.imei') }}</span>
              <strong class="mc-strong__label">{{ form.imei }}</strong>
            </div>
          </b-col>

          <!-- Phone No -->
          <b-col md="3">
            <div class="mb-3">
              <span class="d-block text-muted">{{ $t('master.form.tracker.phoneNo') }}</span>
              <strong class="mc-strong__label">{{ form.phoneNo }}</strong>
            </div>
          </b-col>

          <!-- Vendor -->
          <b-col md="2">
            <div class="mb-3">
              <span class="d-block text-muted">{{ $t('master.form.tracker.vendor') }}</span>
              <strong class="mc-strong__label">{{ form.vendorType }}</strong>
            </div>
          </b-col>

          <!-- Tipe Perangkat -->
          <b-col md="2">
            <div class="mb-3">
              <span class="d-block text-muted">{{ $t('master.form.tracker.device') }}</span>
              <strong class="mc-strong__label">{{ form.deviceCode }}</strong>
            </div>
          </b-col>
        </b-row>

        <!-- Tracking ID -->
        <b-row>
          <div class="mb-3 mx-1 px-1">
            <FormulateInput
              v-model="form.identifier"
              :placeholder="`${$t('global.form.enter')} ${$t('master.list.tracker.trackerId')}`"
              validation="required:trim"
              :validation-messages="{
                required: `${$t('master.form.tracker.trackerId')} ${$t(
                  'global.validation.required'
                )}`,
              }"
              error-behavior="blur"
              help="required"
              validation-behavior="live"
            >
              <template #label>
                <div class="d-flex justify-content-between align-items-center">
                  <label>
                    {{ $t('master.form.tracker.trackerId') }}
                  </label>
                  <span
                    v-b-tooltip.hover.leftbottom
                    :title="$t('master.form.tracker.tooltipChange')"
                  >
                    <i class="bx bx-info-circle" />
                  </span>
                </div>
              </template>
            </FormulateInput>
          </div>
        </b-row>

        <!-- Status -->
        <b-form-group
          id="status_label"
          :label="$t('master.form.tracker.status')"
          label-for="status"
        >
          <div class="mb-3">
            <div class="form-check form-check-inline">
              <input
                id="assignedStatus"
                v-model="form.status"
                class="form-check-input"
                type="radio"
                name="status"
                :value="0"
                :disabled="true"
              />
              <label class="form-check-label" for="assignedStatus">{{ $t('global.active') }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                id="disableStatus"
                v-model="form.status"
                class="form-check-input"
                type="radio"
                name="status"
                :value="2"
                :disabled="true"
              />
              <label class="form-check-label" for="disableStatus">{{ $t('global.archive') }}</label>
            </div>
          </div>
        </b-form-group>
      </FormulateForm>
      <template #modal-footer="{ cancel }">
        <div>
          <McButton
            v-b-modal.modal-history-tracker
            variant="secondary"
            class="me-3"
            :text="$t('master.form.tracker.history')"
            @click="openModalHistoryTracker"
          />
        </div>
        <div>
          <McButton
            variant="secondary"
            class="me-3"
            :text="$t('global.action.cancel')"
            @click="cancel()"
          />
          <McButton
            variant="primary"
            type="submit"
            :text="$t('global.action.save')"
            @click="handleSubmitForm"
          />
        </div>
      </template>
    </b-modal>

    <!-- Riwayat -->
    <b-modal
      id="modal-history-tracker"
      centered
      :title="$t('master.form.tracker.historyTracker') + ' - ' + form.imei"
      title-class="font-18"
      hide-footer
      size="lg"
      @show="deviceLogsReset"
    >
      <b-card class="mc-card__setting">
        <b-tabs content-class="p-3 text-muted">
          <b-tab class="border-0">
            <template #title>
              <span class="d-sm-inline-block">{{ $t('global.changeData') }}</span>
            </template>

            <div>
              <div class="clearfix">
                <!-- Search -->
                <div class="float-end">
                  <div class="mc-table-view">
                    <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                      <label
                        class="d-inline-flex align-items-center mc-table-view__search"
                        @click="focusSearch"
                      >
                        <i class="mc-fa fas fa-search" />
                        <b-form-input
                          v-model="filterHistory"
                          type="search"
                          :placeholder="$t('global.search') + '...'"
                          class="ms-2"
                          ref="searchInput"
                        />
                      </label>
                    </div>
                  </div>
                </div>
                <!-- End search -->
              </div>

              <!-- Table -->
              <div class="table-responsive my-3 border border-1">
                <b-table
                  small
                  show-empty
                  :fields="listHistory"
                  :items="deviceHistories.deviceHistories"
                  class="datatables"
                  responsive="md"
                  :empty-text="$t('global.emptyTable')"
                  :empty-filtered-text="$t('global.emptyFilteredTable')"
                  :per-page="historyPerPage"
                  :current-page="historyPage"
                  :filter="filterHistory"
                  @filtered="onFilteredHistory"
                >
                  <template #cell(activeOn)="row">
                    <div>
                      <p class="font-weight-bold">
                        {{ row.item.activeOnDateFormat }}
                      </p>
                      <p class="text-muted">
                        {{ row.item.activeOnTimeFormat }}
                      </p>
                    </div>
                  </template>
                  <template #cell(inactiveOn)="row">
                    <div>
                      <p class="font-weight-bold">
                        {{ row.item.inactiveOnDateFormat }}
                      </p>
                      <p class="text-muted">
                        {{ row.item.activeOnTimeFormat }}
                      </p>
                    </div>
                  </template>
                </b-table>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <p>
                    {{ $t('global.show') }}
                    <strong>{{
                      historyRows > 0 ? (historyPage - 1) * historyPerPage + 1 : 0
                    }}</strong>
                    {{ $t('global.object.to') }}
                    <strong>{{ Math.min(historyRows, historyPage * 5) }}</strong>
                    {{ $t('global.object.of') }}
                    <strong>{{ historyRows }}</strong>
                    {{ $t('global.entry') }}
                  </p>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="dataTables_paginate paging_simple_numbers float-end mb-0">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="historyPage"
                        :total-rows="historyRows"
                        :per-page="historyPerPage"
                      />
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab class="border-0">
            <template #title>
              <span class="d-sm-inline-block">{{ $t('master.form.tracker.trackerActivity') }}</span>
            </template>

            <div>
              <div class="clearfix">
                <!-- Search -->
                <div class="container">
                  <div class="row justify-content-end">
                    <div class="col-sm-12 col-md-5">
                      <div class="mc-modal__filter-item text-md-end">
                        <mc-date-picker
                          ref="periodePicker"
                          v-model="periode"
                          :placeholder="$t('global.action.selectDate')"
                          format="DD MMM YYYY"
                          value-type="YYYY-MM-DD"
                          :shortcuts="makeShortcuts"
                          :disabled-date="disabledDateLogs"
                          range-separator=" - "
                          range
                          :draft="true"
                          :confirm="true"
                          :clearable="false"
                          :confirm-text="$t('global.action.apply')"
                          @input="changeDateRange"
                        >
                          <template #footer>
                            <b-button
                              class="mx-2"
                              variant="outline-primary"
                              @click="closeCalendar()"
                            >
                              {{ $t('global.action.cancel') }}
                            </b-button>
                          </template>
                        </mc-date-picker>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-4">
                      <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                        <label
                          class="d-inline-flex align-items-center mc-table-view__search"
                          @click="focusSearch"
                        >
                          <i class="mc-fa fas fa-search"></i>
                          <b-form-input
                            ref="searchInput"
                            v-model="filterActivity"
                            type="search"
                            :placeholder="$t('global.search') + '...'"
                            class="ms-2"
                          />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End search -->
              </div>

              <!-- Table -->
              <div class="table-responsive my-3 border border-1">
                <b-table
                  small
                  show-empty
                  :fields="activityHistory"
                  :items="deviceLogs.deviceLogs"
                  class="datatable"
                  responsive="md"
                  :empty-text="$t('global.emptyTable')"
                  :empty-filtered-text="$t('global.emptyFilteredTable')"
                  :per-page="activityPerPage"
                  :current-page="activityPage"
                  :filter="filterActivity"
                  @filtered="onFilteredActivity"
                >
                  <template #cell(messageOn)="row">
                    <div>
                      <p>
                        {{ row.item.messageOnDateFormat }}
                      </p>
                      <p class="text-muted">
                        {{ row.item.messageOnTimeFormat }}
                      </p>
                    </div>
                  </template>
                  <template #cell(description)="row">
                    <p v-if="row.item.type !== 'temperature'">
                      {{ row.item.description }}
                    </p>
                    <p v-if="row.item.type == 'temperature'">
                      {{ $t('master.list.tracker.temperatureSensor') }} =
                      <strong class="font-weight-bold">{{
                        row.item.description.type == 'e'
                          ? $t('master.list.tracker.engine')
                          : $t('master.list.tracker.refrigerator')
                      }}</strong>
                      <br />
                      {{ $t('master.list.tracker.temperatureIdleMin') }} =
                      <strong class="font-weight-bold">{{ row.item.description.hiIdle }}°C </strong>
                      & {{ $t('master.list.tracker.temperatureIdleMax') }} =
                      <strong class="font-weight-bold">{{ row.item.description.loIdle }}°C </strong>
                      <br />
                      {{ $t('master.list.tracker.temperatureMovingMin') }} =
                      <strong class="font-weight-bold">
                        {{ row.item.description.hiMoving }}°C
                      </strong>
                      & {{ $t('master.list.tracker.temperatureMovingMax') }} =
                      <strong class="font-weight-bold">
                        {{ row.item.description.loMoving }}°C
                      </strong>
                    </p>
                  </template>
                </b-table>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <p>
                    {{ $t('global.show') }}
                    <strong>{{
                      activityRows > 0 ? (activityPage - 1) * activityPerPage + 1 : 0
                    }}</strong>
                    {{ $t('global.object.to') }}
                    <strong>{{ Math.min(activityRows, activityPage * activityPerPage) }}</strong>
                    {{ $t('global.object.of') }}
                    <strong>{{ activityRows }}</strong>
                    {{ $t('global.entry') }}.
                  </p>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div class="dataTables_paginate paging_simple_numbers float-end mb-0">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="activityPage"
                        :total-rows="activityRows"
                        :per-page="activityPerPage"
                      />
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-modal>

    <!-- Status -->
    <b-modal
      v-model="showModal"
      :title="$t('global.action.changeStatus')"
      body-class="p-3"
      hide-footer
      size="md"
      centered
    >
      <form @submit.prevent="toChangeStatus">
        <div class="row">
          <p>
            {{ $t('global.alert.text.changeStatus') }}
            <b>{{ status }}</b> ?
          </p>

          <div class="table-responsive">
            <table class="table table-bordered mb-0">
              <thead>
                <tr></tr>
              </thead>
              <tbody>
                <tr v-for="device in selected.tracking" :key="device.imei">
                  <td>{{ device.identifier }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="text-end pt-5 mt-3">
          <McButton variant="secondary" :text="$t('global.no')" @click="showModal = false" />
          <McButton type="submit" variant="primary" class="ms-2" :text="$t('global.yes')" />
        </div>
      </form>
    </b-modal>

    <!-- Filter -->
    <b-modal id="modal-filter" class="mc-modal" title="Filter" size="lg" centered scrollable>
      <div class="card-body mc-modal__filter">
        <form>
          <div class="mc-modal__filter-item">
            <b-form-group v-slot="{ ariaDescribedby }" label="Status">
              <b-form-checkbox-group
                id="checkbox-group-1"
                v-model="selected"
                :options="['Aktif']"
                :aria-describedby="ariaDescribedby"
                name="flavour-1"
              />
            </b-form-group>
          </div>
          <div class="mc-modal__filter-item">
            <label class="mt-3">{{ $t('master.form.tracker.vendor') }}</label>
            <multiselect
              v-model="vendor"
              :options="['McEasy', 'EasyGo', 'Foxlogger', 'Other', 'Tidak Berkategori']"
              :multiple="true"
              placeholder="Vendor"
            />
          </div>
          <div class="mc-modal__filter-item">
            <label>{{ $t('master.form.tracker.deviceType') }}</label>
            <multiselect
              v-model="tipePerangkat"
              :options="['X100', 'TRV102', 'Concox X3', 'FMB103']"
              :multiple="true"
              placeholder="Tipe Perangkat"
            />
          </div>
          <div class="mc-modal__filter-item">
            <div class="form-check form-switch mb-3">
              <input id="switchArsip" type="checkbox" class="form-check-input" />
              <label for="switchArsip" class="form-check-label">
                {{ $t('global.showArchiveStatus') }}
              </label>
            </div>
          </div>
        </form>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col sm="12" md="8" class="mc-modal__filter-footer-fav">
            <b-row>
              <b-col md="6">
                <b-form-group
                  v-if="!isAddFavorit"
                  id="favorit-label-modal"
                  label="Favorit"
                  label-for="favorit-modal"
                >
                  <multiselect
                    v-model="fav"
                    :options="['Semua Status', 'Status Aktif', 'Status Nonaktif']"
                    :show-labels="false"
                  />
                </b-form-group>
                <b-form-group
                  v-if="isAddFavorit"
                  id="favorit-add-label-modal"
                  label="Favorit"
                  label-for="favorit-modal-add"
                >
                  <b-form-input
                    id="favorit-modal-add"
                    v-model="addFavorit"
                    placeholder="Nama Favorit"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <McButton
                  v-if="!isAddFavorit"
                  variant="secondary"
                  icon="mdi-file-plus-outline"
                  :text="$t('master.user.createFavorite')"
                  @click="isAddFavorit = !isAddFavorit"
                />
                <McButton
                  v-if="isAddFavorit"
                  variant="secondary"
                  icon="fa-save"
                  :text="$t('master.user.saveFavorite')"
                />
                <i
                  v-if="isAddFavorit"
                  class="fas fa-trash text-danger text-lg mt-4 ms-3"
                  @click="isAddFavorit = !isAddFavorit"
                ></i>
              </b-col>
            </b-row>
          </b-col>

          <b-col sm="12" md="4" class="mc-modal__filter-footer-btn">
            <McButton
              variant="secondary"
              class="me-3"
              :text="$t('global.action.cancel')"
              @click="cancel()"
            />
            <McButton variant="primary" :text="$t('global.action.apply')" />
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </Layout>
</template>
